// ============================================
// INFRASTRUCTURE - Encuesta Repository
// ============================================

import type { Encuesta } from '../../domain/entities';
import { axiosClient } from './axios-client';

interface SubmitEncuestaPayload {
  encuestaId: number;
  personaContesta: string;
  respuestas: Array<{
    encuestaPreguntaId: number;
    respuesta: string;
  }>;
}

export const encuestaRepository = {
  /**
   * Obtiene una encuesta por su ID
   */
  async getEncuesta(encuestaId: string): Promise<Encuesta> {
    const { data } = await axiosClient.get<Encuesta>(`/encuestas/assemble/${encuestaId}`);
    return data;
  },

  /**
   * Envía las respuestas de una encuesta
   */
  async submitRespuestas(payload: SubmitEncuestaPayload): Promise<void> {
    await axiosClient.post('/encuestas-aplicadas', payload);
  },
};
